import { Link } from "react-router-dom";
import { Logo } from "./Navbar";
import { useSite } from "@/context/SiteContext";

export default function Footer({ profile }) {
  const { t } = useSite();
  return (
    <footer className="bg-[#0B132B] py-12 text-slate-400" data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-wrap items-start justify-between gap-8 px-4 sm:px-6 lg:px-8">
        <div className="max-w-sm">
          <Logo dark />
          <p className="mt-4 text-sm">{profile?.tagline}</p>
        </div>
        <div className="flex gap-10 text-sm">
          <div className="space-y-2"><p className="eyebrow">{t("foot.nav")}</p><a href="/#tentang" className="block hover:text-white">{t("nav.about")}</a><a href="/#layanan" className="block hover:text-white">{t("nav.services")}</a><a href="/#portofolio" className="block hover:text-white">{t("nav.portfolio")}</a><a href="/#faq" className="block hover:text-white">{t("nav.faq")}</a></div>
          <div className="space-y-2"><p className="eyebrow">{t("foot.system")}</p><Link to="/admin/login" className="block hover:text-white">Admin CMS</Link></div>
        </div>
      </div>
      <p className="mx-auto mt-10 max-w-7xl px-4 font-mono text-xs sm:px-6 lg:px-8">© {new Date().getFullYear()} {profile?.company_name}. {t("foot.rights")}</p>
    </footer>
  );
}
